import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const EmailTemplateSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default EmailTemplateSVG;
